
export function transformChartData(categories, series) {
    return series?.length ? series?.map(s => ({
        name: s.name,
        type: s?.type || null,
        data: categories.map((cat, index) => ({
            x: cat,
            y: s.data[index] ?? null
        }))
    })) : [];
}